import {
    CLEAR_REPORT_GENERATION_DETAILS,
    CLEAR_REPORT_GENERATION_LIST,
    SET_REPORT_GENERATION_DETAILS,
    SET_REPORT_GENERATION_LIST,
    REPORT_GENERATION_CREATE_DIALOG_CLOSE,
    REPORT_GENERATION_CREATE_DIALOG_OPEN,
    REPORT_GENERATION_CREATE_ERROR,
    REPORT_GENERATION_CREATE_ERROR_CLEAR,
    REPORT_GENERATION_CREATE_PENDING,
    REPORT_GENERATION_DETAILS_ERROR,
    REPORT_GENERATION_DETAILS_ERROR_CLEAR,
    REPORT_GENERATION_DETAILS_PENDING,
    REPORT_GENERATION_EDIT_DIALOG_CLOSE,
    REPORT_GENERATION_EDIT_DIALOG_OPEN,
    REPORT_GENERATION_EDIT_ERROR,
    REPORT_GENERATION_EDIT_ERROR_CLEAR,
    REPORT_GENERATION_EDIT_PENDING,
    REPORT_GENERATION_LIST_ERROR,
    REPORT_GENERATION_LIST_ERROR_CLEAR,
    REPORT_GENERATION_LIST_PENDING,
    SET_REPORT_SIDEBAR_LIST,
    REPORT_GENERATION_DATA,
    FIELDS_TABLE_DIALOG_OPEN,
    FIELDS_TABLE_DIALOG_CLOSE,
    SET_CURRENT_BIRD_RECORD,
    REPORT_FILTER_DIALOG_OPEN,
    REPORT_FILTER_DIALOG_CLOSE,
    SET_REPORT_FILTER_DATA,
} from "./constants"

const initialState = {

    //-----------------------------|| LIST ||---------------------------------------------------------------
    reportGenerationList: null,
    reportGenerationListCount: 0,
    isReportGenerationListPending: false,
    reportGenerationListErrorMessage: null,
    isFieldsTableDialogOpen: false,
    birdRecord: null,
    farmName: null,
    reportName: null,
    reportValue: null,
    //-----------------------------|| FILTER ||-------------------------------------------------------------
    isReportFilterDialogOpen: false,
    reportFilterData: null,
    //-----------------------------|| DETAILS ||------------------------------------------------------------
    reportGenerationDetails: null,
    isReportGenerationDetailsPending: false,
    reportGenerationDetailsErrorMessage: null,
    //-----------------------------|| CREATE ||-------------------------------------------------------------
    reportGeneratedData: null,
    isReportGenerationCreateDialogOpen: false,
    isReportGenerationCreatePending: false,
    reportGenerationCreateErrorMessage: null,
    //-----------------------------|| EDIT ||---------------------------------------------------------------
    isReportGenerationEditDialogOpen: false,
    isReportGenerationEditPending: false,
    reportGenerationEditErrorMessage: null,
    //-----------------------------|| SIDEBAR ||---------------------------------------------------------------
    reportListSideBar: [],
}

const reportGenerations = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||---------------------------------------------------------------
        case REPORT_GENERATION_LIST_PENDING: {
            return {
                ...state,
                isReportGenerationListPending: true,
                reportGenerationListErrorMessage: null,
            }
        }
        case SET_REPORT_GENERATION_LIST: {
            const { reportGenerationList } = action.payload || {};
            return {
                ...state,
                reportGenerationList: reportGenerationList['value'],
                reportGenerationListCount: reportGenerationList['@odata.count'],
                isReportGenerationListPending: false,
                reportGenerationListErrorMessage: null,
            }
        }
        case REPORT_GENERATION_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                reportGenerationListErrorMessage: errorMessage,
                isReportGenerationListPending: false,
                reportGenerationList: null,
                reportGenerationListCount: 0,
            }
        }
        case REPORT_GENERATION_LIST_ERROR_CLEAR: {
            return {
                ...state,
                reportGenerationListErrorMessage: null,
                isReportGenerationListPending: false,
            }
        }
        case CLEAR_REPORT_GENERATION_LIST: {
            return {
                ...state,
                reportGenerationList: null,
                reportGenerationListCount: 0,
            }
        }
        case FIELDS_TABLE_DIALOG_OPEN: {
            return {
                ...state,
                isFieldsTableDialogOpen: true,
            }
        }
        case FIELDS_TABLE_DIALOG_CLOSE: {
            return {
                ...state,
                isFieldsTableDialogOpen: false,
            }
        }
        case SET_CURRENT_BIRD_RECORD: {
            const { birdRecord, farmName, reportName, reportValue } = action.payload || {};
            return {
                ...state,
                birdRecord: birdRecord,
                farmName: farmName,
                reportName: reportName,
                reportValue: reportValue
            }
        }

        //-----------------------------|| FILTER ||-------------------------------------------------------------
        case REPORT_FILTER_DIALOG_OPEN: {
            return {
                ...state,
                isReportFilterDialogOpen: true,
            }
        }
        case REPORT_FILTER_DIALOG_CLOSE: {
            return {
                ...state,
                isReportFilterDialogOpen: false,
            }
        }
        case SET_REPORT_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...state,
                reportFilterData: filter,
            }
        }

        //-----------------------------|| DETAILS ||---------------------------------------------------------------
        case REPORT_GENERATION_DETAILS_PENDING: {
            return {
                ...state,
                isReportGenerationDetailsPending: true,
                reportGenerationDetailsErrorMessage: null,
            }
        }

        case SET_REPORT_GENERATION_DETAILS: {
            const { reportGenerationDetails } = action.payload || {};
            return {
                ...state,
                reportGenerationDetails: reportGenerationDetails,
                isReportGenerationDetailsPending: false,
                reportGenerationDetailsErrorMessage: null,
            }
        }

        case REPORT_GENERATION_DETAILS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                reportGenerationDetailsErrorMessage: errorMessage,
                isReportGenerationDetailsPending: false,
                reportGenerationDetails: null,
            }
        }

        case REPORT_GENERATION_DETAILS_ERROR_CLEAR: {
            return {
                ...state,
                reportGenerationDetailsErrorMessage: null,
                isReportGenerationDetailsPending: false,
            }
        }
        case CLEAR_REPORT_GENERATION_DETAILS: {
            return {
                ...state,
                reportGenerationDetails: null,
            }
        }

        //-----------------------------|| CREATE ||---------------------------------------------------------------
        case REPORT_GENERATION_DATA: {
            const { reportData } = action.payload || {};
            return {
                ...state,
                reportGeneratedData: reportData,
            }
        }
        case REPORT_GENERATION_CREATE_DIALOG_OPEN: {
            return {
                ...state,
                isReportGenerationCreateDialogOpen: true,
            }
        }
        case REPORT_GENERATION_CREATE_DIALOG_CLOSE: {
            return {
                ...state,
                isReportGenerationCreateDialogOpen: false,
            }
        }

        case REPORT_GENERATION_CREATE_PENDING: {
            return {
                ...state,
                isReportGenerationCreatePending: true,
                reportGenerationCreateErrorMessage: null,
            }
        }

        case REPORT_GENERATION_CREATE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                reportGenerationCreateErrorMessage: errorMessage,
                isReportGenerationCreatePending: false,
            }
        }

        case REPORT_GENERATION_CREATE_ERROR_CLEAR: {
            return {
                ...state,
                reportGenerationCreateErrorMessage: null,
                isReportGenerationCreatePending: false,
            }
        }

        //-----------------------------|| EDIT ||---------------------------------------------------------------
        case REPORT_GENERATION_EDIT_DIALOG_OPEN: {
            return {
                ...state,
                isReportGenerationEditDialogOpen: true,
            }
        }
        case REPORT_GENERATION_EDIT_DIALOG_CLOSE: {
            return {
                ...state,
                isReportGenerationEditDialogOpen: false,
            }
        }

        case REPORT_GENERATION_EDIT_PENDING: {
            return {
                ...state,
                isReportGenerationEditPending: true,
                reportGenerationEditErrorMessage: null,
            }
        }

        case REPORT_GENERATION_EDIT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                reportGenerationEditErrorMessage: errorMessage,
                isReportGenerationEditPending: false,
            }
        }

        case REPORT_GENERATION_EDIT_ERROR_CLEAR: {
            return {
                ...state,
                reportGenerationEditErrorMessage: null,
                isReportGenerationEditPending: false,
            }
        }
        //-----------------------------|| SIDEBAR ||---------------------------------------------------------------
        case SET_REPORT_SIDEBAR_LIST: {
            const { reportList } = action.payload || {};
            return {
                ...state,
                reportListSideBar: reportList['value'],
            }
        }

        default: {
            return state;
        }
    }
}

export default reportGenerations;